/**
 * Slug helpers mirroring the API's own rules.
 *
 * A template's slug is derived server-side and is permanent — it becomes the
 * ECR repository path and the publisher credential's name, and no endpoint can
 * change it afterwards. Showing the resolved value before submitting is the
 * only way a user learns that `My_Template v2!` is about to become
 * `my-template-v2`, so this must stay byte-identical to the server.
 *
 * Source of truth: `slugify` and `isValidSlug` in
 * api/src/services/templateProcessors.ts.
 */

/** Lowercase, collapse every run of non-[a-z0-9] to `-`, trim stray hyphens. */
export const previewSlug = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** The API's acceptance test for a slug. */
export const isValidSlug = (slug: string): boolean => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug || '');
